import { useState, useCallback, useMemo, useEffect } from 'react';
// TODO: (D.K.) Should use simpler way
import { useSwipePosition } from 'use-swipe-hook';
import { useWindowSize } from '@yme/hooks/index';
import { GUTTER_BETWEEN_TABS } from './constants';
import { getScaleValue } from './helpers';
export function useCalculateScaleValue(props) {
    const [scale, setScale] = useState(0);
    const [positionX, setPositionX] = useState(0);
    const { isTabletView, isDesktopView } = useWindowSize();
    const { tabsHolderRef, itemTabRef, halfTabsCount } = props;
    const { x1, x2 } = useSwipePosition({
        ref: tabsHolderRef,
        thresholdPX: 5,
        useRelativeUnits: true,
    });
    const newPositionX1 = Math.floor(x1);
    const newPositionX2 = Math.floor(x2);
    // ref tabs wrapper
    const currentTabsHolderRef = tabsHolderRef?.current;
    // ref item tab wrapper
    const currentItemTabRef = itemTabRef?.current;
    const currentScale = useMemo(() => {
        if (!isDesktopView && isTabletView && currentTabsHolderRef && currentItemTabRef) {
            const { left: gutterLeftHolderSize, width: minWidth } = currentTabsHolderRef.getBoundingClientRect();
            const { right: maxWidth } = currentItemTabRef.getBoundingClientRect();
            const isOffsetOff = minWidth <= maxWidth;
            return getScaleValue({
                minWidth: Math.floor(minWidth),
                maxWidth: Math.floor(maxWidth),
                gutterLeftHolderSize,
                extraGutterSize: GUTTER_BETWEEN_TABS / 2,
                isOffsetOff,
            });
        }
        return 0;
    }, [currentItemTabRef, currentTabsHolderRef, isDesktopView, isTabletView]);
    const onMoveToLeft = (value) => {
        setScale(value);
    };
    const onMoveToRight = (value) => {
        setScale(value);
    };
    const animationTabsHandler = useCallback((activeTabId) => {
        const isLeftDirection = activeTabId <= halfTabsCount;
        const isRightDirection = activeTabId > halfTabsCount;
        // if activeTab is in the first half of the tab list
        if (isLeftDirection) {
            onMoveToLeft(0);
        }
        // if activeTab is in the last half of the tab list
        if (isRightDirection && currentScale !== 0) {
            onMoveToRight(currentScale);
        }
    }, [halfTabsCount, currentScale]);
    const handleEnd = useCallback(() => {
        if (positionX !== newPositionX1 && newPositionX2 > newPositionX1) {
            onMoveToLeft(0);
        }
        if (positionX !== newPositionX1 && newPositionX2 < newPositionX1) {
            onMoveToRight(currentScale);
        }
    }, [currentScale, newPositionX1, newPositionX2, positionX]);
    const handleTouchStart = useCallback((event) => {
        const currentPositionX = event.touches[0].clientX;
        setPositionX(Math.floor(currentPositionX));
    }, []);
    const handleTouchMove = useCallback(() => {
        setPositionX(Math.floor(newPositionX2));
    }, [newPositionX2]);
    const handleTouchEnd = useCallback((event) => {
        if (event.changedTouches && event.changedTouches.length > 0) {
            setPositionX(Math.floor(event.changedTouches[0].clientX));
            handleEnd();
        }
    }, [handleEnd]);
    useEffect(() => {
        document.addEventListener('touchstart', handleTouchStart);
        document.addEventListener('touchmove', handleTouchMove);
        document.addEventListener('touchend', handleTouchEnd);
        return () => {
            document.removeEventListener('touchstart', handleTouchStart);
            document.removeEventListener('touchmove', handleTouchMove);
            document.removeEventListener('touchend', handleTouchEnd);
        };
    }, [handleTouchEnd, handleTouchMove, handleTouchStart]);
    return {
        scale,
        isShowLeftGradient: scale === 0,
        isShowRightGradient: scale < 0,
        animationTabsHandler,
    };
}
